import { render, staticRenderFns } from "./_genreSlug.vue?vue&type=template&id=6e653034"
import script from "./_genreSlug.vue?vue&type=script&lang=js"
export * from "./_genreSlug.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports